import cookieManager from "../../../../utils/cookieManager";
import axios from "axios";
import PurchaseReturnActions from "../../../../reducers/modules/purchasing/purchase-return/actions";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Navigate } from "react-router-dom";

const MySwal = withReactContent(Swal);
const url = process.env.REST_URL + "purchasing/purchase-return";

export default class PurchaseReturnMiddleware {
  static create() {
    return (dispatch) => {
      dispatch(PurchaseReturnActions.create());
    };
  }

  static update(params) {
    return (dispatch) => {
      dispatch(PurchaseReturnActions.update());
      PurchaseReturnMiddleware.showOne(dispatch, params);
    };
  }

  static list(params) {
    return (dispatch) => {
      dispatch(PurchaseReturnActions.process());
      PurchaseReturnMiddleware.showlist(dispatch, params);
    };
  }
  static resetList() {
    return (dispatch) => {
      dispatch(PurchaseReturnActions.resetList());
    };
  }
  static reset() {
    return (dispatch) => {
      dispatch(PurchaseReturnActions.reset());
    };
  }
  static getOne(params) {
    return (dispatch) => {
      dispatch(PurchaseReturnActions.view());
      PurchaseReturnMiddleware.showOne(dispatch, params);
    };
  }
  static getPrint(params) {
    return (dispatch) => {
      dispatch(PurchaseReturnActions.beforePrint());
      PurchaseReturnMiddleware.showPrint(dispatch, params);
    };
  }

  static beforeSaveNew(post, search) {
    return (dispatch) => {
      dispatch(PurchaseReturnActions.submit());
      PurchaseReturnMiddleware.saveNew(dispatch, post, search);
    };
  }

  static beforeCancel(id, params) {
    return (dispatch) => {
      dispatch(PurchaseReturnActions.cancel());
      PurchaseReturnMiddleware.cancel(dispatch, params, id);
    };
  }

  static getHelper(params = null) {
    return (dispatch) => {
      PurchaseReturnMiddleware.showHelper(dispatch, params);
    };
  }

  static getHelperFull(params = null) {
    return (dispatch) => {
      PurchaseReturnMiddleware.showHelperFull(dispatch, params);
    };
  }

  static getToken() {
    return cookieManager.getUserToken();
  }

  static showHelperFull(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PurchaseReturnMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "helper/get-helper-pret",
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(PurchaseReturnActions.helperFull(response.data.result));
        }
      })
      .catch((error) => {
        PurchaseReturnMiddleware.alertHendler(dispatch, error);
      });
  }
  static showlist(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PurchaseReturnMiddleware.getToken()}`,
      },
      url: url,
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(PurchaseReturnActions.list(response.data.result));
        }
      })
      .catch((error) => {
        PurchaseReturnMiddleware.alertHendler(dispatch, error);
      });
  }
  static showHelper(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PurchaseReturnMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "helper/get-purchase-order",
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(PurchaseReturnActions.helper(response.data.result));
        }
      })
      .catch((error) => {
        PurchaseReturnMiddleware.alertHendler(dispatch, error);
      });
  }
  static showOne(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PurchaseReturnMiddleware.getToken()}`,
      },
      url: url + "/" + params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(PurchaseReturnActions.view(response.data.result));
        }
      })
      .catch((error) => {
        PurchaseReturnMiddleware.alertHendler(dispatch, error);
      });
  }

  static showPrint(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PurchaseReturnMiddleware.getToken()}`,
      },
      url: url + "/print/" + params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(PurchaseReturnActions.print(response.data.result));
        }
      })
      .catch((error) => {
        PurchaseReturnMiddleware.alertHendler(dispatch, error);
      });
  }

  static delete(dispatch, params, id) {
    axios({
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PurchaseReturnMiddleware.getToken()}`,
      },
      url: url + "/" + id,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            PurchaseReturnActions.process(),
            PurchaseReturnMiddleware.showlist(dispatch, params)
          );
          PurchaseReturnMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Delete Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        PurchaseReturnMiddleware.alertHendler(dispatch, error, true);
      });
  }

  static cancel(dispatch, params, id) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PurchaseReturnMiddleware.getToken()}`,
      },
      url: url + "/" + id,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            PurchaseReturnActions.process(),
            PurchaseReturnMiddleware.showlist(dispatch, params)
          );
          PurchaseReturnMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Cancel Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        PurchaseReturnMiddleware.alertHendler(dispatch, error, true);
      });
  }

  static saveNew(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PurchaseReturnMiddleware.getToken()}`,
      },
      url: url,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            PurchaseReturnActions.process(),
            PurchaseReturnMiddleware.showlist(dispatch, search)
          );
          dispatch(PurchaseReturnActions.success());
          PurchaseReturnMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Create Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        PurchaseReturnMiddleware.alertHendler(dispatch, error);
      });
  }

  static saveUpdate(dispatch, params, post, search) {
    axios({
      method: "PUT",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${PurchaseReturnMiddleware.getToken()}`,
      },
      url: url + "/" + params,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            PurchaseReturnActions.process(),
            PurchaseReturnMiddleware.showlist(dispatch, search)
          );
          dispatch(PurchaseReturnActions.success());
          PurchaseReturnMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Update Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        PurchaseReturnMiddleware.alertHendler(dispatch, error);
      });
  }
  static alertHendler(
    dispatch,
    result,
    isSwal = false,
    extraMessage = "",
    type = "error"
  ) {
    if (type == "error") {
      if (result.response) {
        const status = result.response.status;
        switch (status) {
          case 500:
            if (isSwal) {
              const data = result.response.data;
              MySwal.hideLoading();
              MySwal.update({
                title: "Delete Error",
                html: data.error,
                icon: "error",
                showConfirmButton: true,
              });
            } else {
              const data = result.response.data;
              dispatch(PurchaseReturnActions.error(data.error));
            }
            break;
          case 403:
            console.log("Error 403");
            break;
          case 404:
            console.log("Error 404");
            break;
          case 401:
            const data = result.response.data;
            MySwal.fire({
              title: "Login Invalid",
              html: data.error,
              icon: "error",
              showConfirmButton: true,
            }).then((result) => {
              if (result.isConfirmed) {
                <Navigate to="/login"></Navigate>;
              }
            });
            break;
        }
      } else if (result.request) {
        MySwal.fire({
          title: "Internal Server Error",
          html: "Please info your Developer to fix this",
          icon: "error",
          showConfirmButton: true,
        });
        dispatch(PurchaseReturnActions.reset());
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", result.message);
      }
    } else {
      MySwal.fire({
        title: "Success",
        html: extraMessage,
        icon: "success",
        showConfirmButton: true,
      });
    }
  }
}
